import { IModuleMetaData } from "./company-module";

export class MaxDocumentsMetaData {
	private metadata:IModuleMetaData;

	private constructor(metadata:IModuleMetaData){
		this.metadata = metadata;
	}

	public static create(metadata:IModuleMetaData):MaxDocumentsMetaData{
		return new MaxDocumentsMetaData(metadata || {});
	}

	public getMaxDocumentsPerMonth():number{
		return parseInt(this.metadata["max-documents-per-month"] || "0") || 0;
	}

	public setMaxDocumentsPerMonth(count:number):MaxDocumentsMetaData {
		this.metadata["max-documents-per-month"] = `${count}`;
		return this;
	}

	public getDocumentsMadeCount():number{
		return parseInt(this.metadata["documents-made-count"] || "0") || 0;
	}

	public setDocumentsMadeCount(count:number):MaxDocumentsMetaData {
		this.metadata["documents-made-count"] = `${count}`;
		return this;
	}

	public getLastDocumentMadeDate():Date {
		return new Date((parseInt(this.metadata["last-document-made-date"]) * 1000) || 0);
	}

	public setLastDocumentMadeDate(d:Date):MaxDocumentsMetaData {
		this.metadata["last-document-made-date"] = `${Math.round(d.getTime() / 1000)}`;
		return this;
	}
}